export const WOC_Winners = [
    {
      category: "NODE JS",
      FW: [
        { position: "1st", name: "Jaymin Dave", price: 1000, student_id: "202412016" },
        { position: "2nd", name: "Jay Rathod", price: 600, student_id: "202201255" },
        { position: "3rd", name: "Krish Makwana", price: 400, student_id: "202301103" },
      ],
      MW: [
        { position: "1st", name: "Mann Shrimali", price: 250, student_id: "202412046" },
        { position: "2nd", name: "Aryan Rathod", price: 150, student_id: "202301164" },
      ],
    },
    {
      category: "NLP (Natural Language Processing)",
      FW: [
        { position: "1st", name: "Ujjwal Bhansali", price: 1000, student_id: "202418058" },
        { position: "2nd", name: "Krisha Amit Sompura", price: 600, student_id: "202418026" },
        { position: "3rd", name: "Monson Reji Verghese", price: 400, student_id: "202411039" },
      ],
      MW: [
        { position: "1st", name: "Eric Thomas", price: 250, student_id: "202418057" },
        { position: "2nd", name: "Tanay Kewalramani", price: 150, student_id: "202201362" },
      ],
    },
    {
      category: "React",
      FW: [
        { position: "1st", name: "Dev Trivedi", price: 1000, student_id: "202301150" },
        { position: "2nd", name: "Madhav Jivani", price: 600, student_id: "202201285" },
        { position: "3rd", name: "Om Chavda", price: 400, student_id: "202301177" },
      ],
      MW: [
        { position: "1st", name: "Nipurna Patel", price: 250, student_id: "202201061" },
        { position: "2nd", name: "Jaikrit Sanandiya", price: 150, student_id: "202201484" },
      ],
    },
    {
      category: "HTML-CSS-JS",
      FW: [
        { position: "1st", name: "Tanishq Shah", price: 1000, student_id: "202401474" },
        { position: "2nd", name: "Shubham Gopal Prasad", price: 600, student_id: "202403042" },
        { position: "3rd", name: "Dhruvish Tandel", price: 400, student_id: "202403044" },
      ],
      MW: [
        { position: "1st", name: "Shah Varshil Chintanbhai", price: 250, student_id: "202401194" },
        { position: "2nd", name: "Siddh Shah", price: 150, student_id: "202401473" },
      ],
    },
    {
      category: "Flutter",
      FW: [
        { position: "1st", name: "Kirtan Pithadiya", price: 1000, student_id: "202412073" },
        { position: "2nd", name: "Jeet Daiya", price: 600, student_id: "202301017" },
        { position: "3rd", name: "Atik Vohra", price: 400, student_id: "202301447" },
      ],
      MW: [
        { position: "1st", name: "Vrushil Parikh", price: 250, student_id: "202412060" },
        { position: "2nd", name: "Kresha Vora", price: 150, student_id: "202301231" },
      ],
    },
    {
      category: "Django",
      FW: [
        { position: "1st", name: "Shamit", price: 1000, student_id: "202301041" },
        { position: "2nd", name: "Kavya", price: 600, student_id: "202412037" },
        { position: "3rd", name: "Sakshi Patadiya", price: 400, student_id: "202101469" },
      ],
      MW: [
        { position: "1st", name: "Virendrasingh Pawar", price: 250, student_id: "202412071" },
        { position: "2nd", name: "Hemal Ravrani", price: 150, student_id: "202201235" },
      ],
    },
    {
      category: "Python GUI",
      FW: [
        { position: "1st", name: "Dharmraj Vaghela", price: 1000, student_id: "202401236" },
      ],
      MW: [
        { position: "1st", name: "Vyom Patel", price: 400, student_id: "202401245" },
        { position: "2nd", name: "Aryan Kanani", price: 250, student_id: "202401250" },
        { position: "3rd", name: "Dhruva Bhatiya", price: 150, student_id: "202401029" },
      ],
    },
    {
      category: "Spring Boot",
      FW: [
        { position: "1st", name: "Sabva Jay Dilipbhai", price: 1000, student_id: "202101224" },
        { position: "2nd", name: "Krish Bhingradiya", price: 600, student_id: "202203033" },
        { position: "3rd", name: "Jeet Desai", price: 400, student_id: "202201474" },
      ],
      MW: [
        { position: "1st", name: "Harita Rathod", price: 250, student_id: "202301211" },
        { position: "2nd", name: "Jenil Soni", price: 150, student_id: "202412108" },
      ],
    },
    {
      category: "System Programming",
      FW: [
        { position: "1st", name: "Rishik Yalamanchili", price: 1000, student_id: "202301258" },
        { position: "2nd", name: "Dhruvil Patel", price: 600, student_id: "202301035" },
      ],
      MW: [
        { position: "1st", name: "Kaushik Prajapati", price: 400, student_id: "202201472" },
        { position: "2nd", name: "Harshil Vasava", price: 250, student_id: "202301208" },
        { position: "3rd", name: "Venkat", price: 150, student_id: "202301280" },
      ],
    },
];
  